import BatteryCells from './BatteryCells';

export default BatteryCells;
